module.exports = __webpack_public_path__ + "img/nocontent.65394b3d.png";